/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoModelsSelectListItem
 */
export interface EfsMelcoModelsSelectListItem {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsSelectListItem
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsSelectListItem
     */
    display_text?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoModelsSelectListItem
     */
    is_default?: boolean;
}

export function EfsMelcoModelsSelectListItemFromJSON(json: any): EfsMelcoModelsSelectListItem {
    return EfsMelcoModelsSelectListItemFromJSONTyped(json, false);
}

export function EfsMelcoModelsSelectListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsSelectListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'display_text': !exists(json, 'display_text') ? undefined : json['display_text'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
    };
}

export function EfsMelcoModelsSelectListItemToJSON(value?: EfsMelcoModelsSelectListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'display_text': value.display_text,
        'is_default': value.is_default,
    };
}


